import { validaCpf } from 'util/validations'
import * as yup from 'yup'
import { pt } from 'yup-locale-pt'

yup.setLocale(pt)
export const schemaCpfLanding = yup.object().shape({
  cpf: yup
    .string()
    .test('test-invalid-cpf', 'Cpf inválido', (cpf) => validaCpf(cpf || ''))
    .required()
    .label('Cpf')
})

export const schemaCpfProdutos = yup.object().shape({
  cpf: yup
    .string()
    .test('test-invalid-cpf', 'Cpf inválido', (cpf) => validaCpf(cpf || ''))
    .required()
    .label('Cpf')
})
